import React from 'react';
import { TicketKey } from 'flow/types/EntityKeys';

import ContactItem from 'flow/components/tickets/convenience/ContactItem';
import AwaitingActivityBadge from './AwaitingActivityBadge';
import SectionHeaderContextMenu from './SectionHeaderContextMenu';
import SectionHeaderStatus from './SectionHeaderStatus';

type Props = {
    ticketKey: TicketKey;
    isSelected: boolean;
    muted?: boolean;
};

const SectionHeader = ({ ticketKey, isSelected, muted }: Props) => {
    const colorBackplates = isSelected ? 'bg-gray-300' : 'bg-gray-200';

    return (
        <div className="flex h-6 items-center justify-between">
            <div className="flex min-w-0 items-center gap-x-2">
                <AwaitingActivityBadge ticketKey={ticketKey} />
                <ContactItem
                    ticketKey={ticketKey}
                    useBold={true}
                    colorBackplates={colorBackplates}
                    muted={muted}
                />
            </div>
            <div className="ms-2 flex items-center gap-2">
                <SectionHeaderStatus ticketKey={ticketKey} />
                <SectionHeaderContextMenu ticketKey={ticketKey} />
            </div>
        </div>
    );
};

export default React.memo(SectionHeader);
